import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import LoadingSpinner from "flexbiz-core/components/LoadingSpinner";

// Quét tất cả các module có thể load
const scr = import.meta.env.VITE_APP_SRC || "erp";
const componentImporters = import.meta.glob(`./apps/**/*.js`);

const DynamicComponent = ({ path, ...restProps }) => {
  const [LoadedComponent, setLoadedComponent] = useState(null);
  // Tìm đúng importer theo path
  const importer = useMemo(() => {
    if (!path) return null;
    const pathKey = `./apps/${scr}/${path}.js`;
    return componentImporters[pathKey] || null;
  }, [path]);

  // Khi path thay đổi, load component mới
  useEffect(() => {
    if (!importer) {
      console.error(`DynamicComponent: Component "${path}" not found.`);
      setLoadedComponent(() => () => <div>Component not found.</div>);
      return;
    }
    let active = true;
    const load = async () => {
      try {
        const module = await importer();
        if (active && module?.default) {
          setLoadedComponent(() => module.default);
        }
      } catch (err) {
        console.error("DynamicComponent load error:", err);
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [importer]);

  // Nếu chưa có component nào load
  if (!LoadedComponent) return <LoadingSpinner style={{color:"white"}} />;

  return <LoadedComponent {...restProps} />
};

DynamicComponent.propTypes = {
  path: PropTypes.string.isRequired,
};

export default DynamicComponent;
